/**
 * `/api/v1/smt/saved-estates` — M-FB1 / audit v2 virhe 1.
 *
 * Mirrors the backend Create/List/Delete endpoints. The "Tallenna arvio"
 * button on the comparison detail page calls `createSavedEstate`; the new
 * "Tallennetut" tab in my-estates.ts uses `listSavedEstates` /
 * `deleteSavedEstate`.
 */
import { request, requestData } from './client.ts';

export interface SavedEstate {
  id: number;
  user_id: number;
  estate_id: number;
  note?: string | null;
  created_at: string;
  estate_name?: string | null;
  region?: string | null;
  municipality?: string | null;
}

export interface CreateSavedEstateInput {
  estate_id: number;
  note?: string;
}

/** POST /smt/saved-estates — idempotent (re-saving returns existing row). */
export async function createSavedEstate(input: CreateSavedEstateInput): Promise<SavedEstate> {
  return requestData<SavedEstate>('/smt/saved-estates', { method: 'POST', body: input });
}

/** GET /smt/saved-estates — caller's bookmarks, newest first. */
export async function listSavedEstates(): Promise<SavedEstate[]> {
  return (await requestData<SavedEstate[] | null>('/smt/saved-estates')) ?? [];
}

/** DELETE /smt/saved-estates/:id — remove a bookmark. The backend
 *  returns 204 (no body), so we use `request` directly rather than
 *  `requestData` (which assumes a `{ data: T }` wrapper). */
export async function deleteSavedEstate(id: number): Promise<void> {
  await request<unknown>(`/smt/saved-estates/${id}`, { method: 'DELETE' });
}
